import React, { ChangeEvent, Component, useContext, useEffect, useState } from "react";
import "./EditWorkflowModal.scss";
import OwButton from "../../../shared/OwButton/OwButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import { OwFnInput } from "../../../shared/OwFnInput/OwFnInput";
import IWorkflow from "../../../../models/IWorkflow";
import IProcessWorkflowDTO from "../../../../models/DTO/IProcessWorkflowDTO";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import INewWorkflow from "../../../../models/INewWorkflow";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IOnProcessWorkflowDTO from "../../../../models/DTO/IOnProcessWorkflowDTO";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    workflow?: IWorkflow;
};

export const EditWorkflowModal: React.FC<Props> = (props) => {
    const closeModal = () => {
        props.closeModalFn();
    };

    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [name, setName] = useState(props.workflow?.name || "");
    const [defaultWorkflow, setDefaultWorkflow] = useState(props.workflow?.id === supplierModel.default_workflow_id);

    const create = () => {};

    useEffect(() => {
        props.socket.on(EndpointsEnum.WorkflowsOnProcessWorkflow, onProcessWorkflow);

        return () => {
            props.socket.removeListener(EndpointsEnum.WorkflowsOnProcessWorkflow, onProcessWorkflow);
        };
    }, []);

    const handleChange = (e: ChangeEvent<any>) => {
        const _name = e.target.name;
        const value = e.target.value;

        switch (_name) {
            case "name":
                setName(value);
                break;

            case "defaultWorkflow":
                setDefaultWorkflow(value);
                break;
        }
    };

    const saveWorkflow = () => {
        const workflow: IWorkflow | INewWorkflow = {
            name,
            supplier_id: supplierModel.id,
            detail: [],
        };

        if (props.workflow) {
            // @ts-expect-error
            workflow.guid = props.workflow.guid;
            workflow.detail = props.workflow.detail;
        }

        const payload: IProcessWorkflowDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            workflow,
            defaultWorkflow,
        };

        props.socket.emit(EndpointsEnum.WorkflowsProcessWorkflow, payload);
    };

    const onProcessWorkflow = (data: IOnProcessWorkflowDTO) => {
        closeModal();
    };

    return (
        <div className={"EditWorkflowModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"workflow"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <OwFnInput fn={handleChange} name={"name"} value={name} />
                </div>

                <div className={"mt-3"}>
                    <OwToggle fn={handleChange} name={"defaultWorkflow"} active={defaultWorkflow} label={"default_workflow"} />
                </div>

                <div className={"mt-3"}>
                    <OwButton title={"save"} fn={saveWorkflow} />
                </div>
            </div>
        </div>
    );
};
